import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Controller, useFormContext } from 'react-hook-form'

import { formatErrorMessage } from 'helpers/contactRequestForm'

import AntDropdown from 'components/AntDropdown'
import FormItem from 'components/Form/Item'

const categoryToOption = (intl) => ({ id, name }) => ({
  id,
  text: intl.formatMessage({ id: `event_categories.${name}` }),
})

const dropdownData = (intl, eventCategories) => ([
  {
    text: intl.formatMessage({ id: 'contactRequestForm.eventCategory.b2b' }),
    children: eventCategories.filter(category => !category.isB2c).map(categoryToOption(intl)),
    type: 'b2b',
  },
  {
    text: intl.formatMessage({ id: 'contactRequestForm.eventCategory.b2c' }),
    children: eventCategories.filter(category => category.isB2c).map(categoryToOption(intl)),
    type: 'b2c',
  },
])

const EventType = (props) => {
  const {
    intl,
    eventCategories,
    initialValue,
    forceFirstEventCategory,
  } = props

  const form = useFormContext()

  if (forceFirstEventCategory) {
    return (
      <input type="hidden" {...form.register('eventCategoryId')} value={eventCategories?.[0]?.id} />
    )
  }

  return (
    <FormItem
      name="eventCategoryId"
      label={`${intl.formatMessage({ id: 'contactRequestForm.eventCategoryId' })}*`}
    >
      <Controller
        name="eventCategoryId"
        defaultValue={initialValue}
        rules={{ required: formatErrorMessage(intl, 'eventCategoryId') }}
        render={({
          field: { onChange, onBlur, value, name, ref },
        }) => (
          <AntDropdown
            className="contact-request-form__event-category-id"
            ref={ref}
            placeholder={intl.formatMessage({ id: 'contactRequestForm.pleaseSelect' })}
            segments={[
              {
                name,
                options: dropdownData(intl, eventCategories),
                currentValue: value,
              },
            ]}
            useNativeSelectOnMobile={true}
            onChange={(values) => onChange(values.eventCategoryId.toString())}
            onBlur={onBlur}
          />
        )}
      />
    </FormItem>
  )
}

EventType.propTypes = {
  intl: PropTypes.object.isRequired,
  eventCategories: PropTypes.arrayOf(PropTypes.object),
  initialValue: PropTypes.string,
  forceFirstEventCategory: PropTypes.bool,
}

export default injectIntl(EventType)
